import React, { Component } from "react";
import axios from "axios";
import moment from "moment";
import Drone from "./../../../images/drone.svg";
import "ol/ol.css";
import { Map, View } from "ol";
// import Geometry from 'ol/geom/Geometry';
import Polygon from "ol/geom/Polygon";
import Feature from "ol/Feature";
import XYZ from "ol/source/XYZ.js";
// import {getCenter} from 'ol/extent';
// import {extend} from 'ol/extent'
// import {
//    GeoJSON,
//    XYZ
// } from 'ol/format'
import {
  // LayerGroup,
  Image as ImageLayer,
  Tile as TileLayer,
  Vector as VectorLayer,
} from "ol/layer";
import {
  ImageWMS as ImageWMSSource,
  // OSM as OSMSource,
  // XYZ as XYZSource,
  TileImage as TileImageSource,
  // TileWMS as TileWMSSource,
  Vector as VectorSource,
} from "ol/source";
import {
  Style,
  // Fill as FillStyle,
  Stroke as StrokeStyle,
} from "ol/style";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import icon_drone from "./../../../images/icon/drone.svg";
import icon_satellite from "./../../../images/icon/satellite.svg";
import icon_image from "./../../../images/icon/type_image.png";

import Projection from "ol/proj/Projection";
import { fromLonLat } from "ol/proj";
import icon_info from "./../../../images/icon/info.svg";
import { Translation } from "react-i18next";
import NumberFormat from "react-number-format";

function SeparatorNumber(lang, number, decimal) {
  if (lang === "en") {
    return (
      <React.Fragment>
        <NumberFormat
          value={number}
          displayType={"text"}
          thousandSeparator={","}
          decimalSeparator={"."}
          decimalScale={decimal}
          className="black"
        />
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <NumberFormat
          value={number}
          displayType={"text"}
          thousandSeparator={"."}
          decimalSeparator={","}
          decimalScale={decimal}
          className="black"
        />
      </React.Fragment>
    );
  }
}

export class ProgramArea extends Component {
  constructor(props) {
    super(props);
    this.state = {
      program: this.props.prorgam,
      user: this.props.user,
      drone: this.props.drone,
      area: this.props.blockArea,
      coordinate: this.props.block,
      blockName: this.props.blockName,
      geoserver: process.env.REACT_APP_GEOSERVER,
      mapserver: process.env.REACT_APP_MAPSERVER,
      loc_id: null,
      loc_date: null,
      isChecked: false,
      activeClass: null,
      layer_type: null,
      droneSummary: {},
      lang: "en",
    };
  }

  componentDidMount() {
    this.setState({
      lang: window.localStorage.i18nextLng,
    });
    const { drone } = this.props;
    if (drone !== null) {
      console.log("Received droneId:", drone);
      // Perform actions with droneId
      this.getDroneLayer(this.props.program, drone);
    } else {
      console.log("Not received droneId");
    }
    this.getDroneImagery();
  }

  getDroneImagery = () => {
    const polygon = new Polygon([
      this.state.coordinate.map((x) => fromLonLat([x.lng, x.lat])),
    ]);
    const vectorPolygon = new VectorLayer({
      visible: true,
      source: new VectorSource({
        features: [
          new Feature({
            geometry: polygon,
            name: this.state.blockName,
            area: this.state.area,
          }),
        ],
      }),
      style: [
        new Style({
          stroke: new StrokeStyle({
            color: "#445CFE",
            width: 3,
          }),
        }),
      ],
    });
    var tci_layers = new TileLayer({
      title: `tci`,
      visible: false,
      id: `tci`,
      source: new XYZ({
        attributions: "",
        url: null,
        tileSize: [256, 256],
      }),
    });
    var landcover_layers = new TileLayer({
      title: `scl`,
      visible: false,
      id: `scl`,
      source: new XYZ({
        attributions: "",
        url: null,
        tileSize: [256, 256],
      }),
    });
    var features = vectorPolygon.getSource().getFeatures();
    var extent = features[0].values_.geometry.extent_;

    this.map = new Map({
      // controls: DefaultControls().extend([
      //    new ZoomSlider(),
      //    new MousePosition(),
      //    new ScaleLine(),
      //    new OverviewMap()
      // ]),
      target: "map",
      layers: [
        // new TileLayer({
        //    source: new OSMSource(),
        // }),
        new TileLayer({
          source: new TileImageSource({
            url: "https://khms3.googleapis.com/kh?v=946&hl=id-ID&x={x}&y={y}&z={z}",
          }),
          visible: true,
        }),
        vectorPolygon,
        tci_layers,
        landcover_layers,
      ],
      view: new View({
        zoom: 8,
      }),
    });
    this.map.getView().fit(extent, { padding: [100, 100, 100, 100] });
    //console.log(this.map.getLayers().getArray()[2]);
  };

  getDroneLayer = (idprogram, droneId) => {
    axios
      .get(
        process.env.REACT_APP_API_HOST +
          "/profile/drone-layer/" +
          idprogram +
          "/" +
          droneId
      )
      .then((res) => {
        //console.log("drone layer ", res.data);
        if (res.data.status) {
          console.log("drone layer ", res.data.data);
          this.map
            .getLayers()
            .getArray()[2]
            .getSource()
            .setUrl(
              `${process.env.REACT_APP_MAPSERVER}/layer/${res.data.data.drone.imagesBlobContainerName}/${res.data.data.drone.imagesBlobPathResult}/tci/{z}/{x}/{y}.png`
            );
          this.map
            .getLayers()
            .getArray()[3]
            .getSource()
            .setUrl(
              `${process.env.REACT_APP_MAPSERVER}/layer/${res.data.data.drone.imagesBlobContainerName}/${res.data.data.drone.imagesBlobPathResult}/scl/{z}/{x}/{y}.png`
            );

          this.setState({
            droneSummary: res.data.data.drone,
          });
        }
      });
  };

  handleLayerClick = (layerName) => {
    // Update the activeClass state when a layer is clicked
    this.setState({ activeClass: layerName });
    if (layerName === "layer-tci") {
      this.setState({
        layer_type: "TCI",
      });
      this.map.getLayers().item(2).setVisible(true);
      this.map.getLayers().item(3).setVisible(false);
    } else if (layerName === "layer-landcover") {
      this.setState({
        layer_type: "Land cover",
      });
      this.map.getLayers().item(2).setVisible(false);
      this.map.getLayers().item(3).setVisible(true);
    }
  };

  render() {
    const { activeClass } = this.state;
    return (
      <React.Fragment>
        <div className="map-wrapper" style={{ position: "relative" }}>
          {this.props.drone ? (
            <>
              <div className="map-area-option">
                <Tabs>
                  <TabList className="custom-tablist">
                    <Tab
                      className="custom-tab annual"
                      style={{ border: "none" }}
                    >
                      <div className="tab-option">
                        <span>Drone</span>
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g id="Drone-01">
                            <g id="Vector">
                              <path
                                d="M12 17.0212C12.3773 17.0212 12.6831 16.7154 12.6831 16.3382C12.6831 15.9609 12.3773 15.6551 12 15.6551C11.6228 15.6551 11.317 15.9609 11.317 16.3382C11.317 16.7154 11.6228 17.0212 12 17.0212Z"
                                fill="#1A1C19"
                              />
                              <path
                                d="M21 5.69067V4.63599H16.1585V5.69067H18.0519V7.38067H17.1654V8.2671H14.1571L13.2104 6.37369H10.7896L9.84288 8.2671H6.83453V7.38067H5.9481V5.69067H7.84151V4.63599H3V5.69067H4.89341V7.38067H4.00698V8.79444C4.00698 9.57526 4.63997 10.2082 5.42075 10.2082C6.01511 10.2082 6.52343 9.84129 6.7325 9.32179H8.63256L9.31558 10.6879H14.6844L15.3674 9.32179H17.2675C17.4766 9.84129 17.9849 10.2082 18.5792 10.2082C19.3601 10.2082 19.993 9.57526 19.993 8.79444V7.38067H19.1066V5.69067H21Z"
                                fill="#1A1C19"
                              />
                              <path
                                d="M15.026 13.3123H13.3542V11.7426H10.7896V13.3123H8.97407C8.30561 13.3123 7.76367 13.8542 7.76367 14.5227V18.1538C7.76367 18.8223 8.30557 19.3642 8.97407 19.3642H15.026C15.6944 19.3642 16.2363 18.8223 16.2363 18.1538V14.5227C16.2363 13.8542 15.6944 13.3123 15.026 13.3123ZM12 18.076C11.0418 18.076 10.2623 17.2964 10.2623 16.3382C10.2623 15.3801 11.0418 14.6005 12 14.6005C12.9582 14.6005 13.7377 15.3801 13.7377 16.3382C13.7377 17.2964 12.9582 18.076 12 18.076Z"
                                fill="#1A1C19"
                              />
                            </g>
                          </g>
                        </svg>
                      </div>
                    </Tab>
                    {/* <Tab
                      className="custom-tab annual"
                      style={{ border: "none" }}
                    >
                      <div className="tab-option">
                        <span>Satellite</span>
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g id="Satelite-01">
                            <g id="Vector">
                              <path
                                d="M7.86873 16.8735L9.38764 15.3546L11.2513 17.2182L9.73242 18.7372L7.86873 16.8735Z"
                                fill="#1A1C19"
                              />
                              <path
                                d="M12.7436 6.78164L14.2625 5.26272L16.1262 7.12642L14.6073 8.64533L12.7436 6.78164Z"
                                fill="#1A1C19"
                              />
                              <path
                                d="M11.9993 16.4735L12.8419 15.6309C12.9298 16.0765 13.1458 16.5017 13.4904 16.8463L14.4225 17.7783L15.7272 16.4735L16.4728 17.2191L17.2184 16.4735L16.4728 15.728L17.7776 14.4232L16.8456 13.4912C16.501 13.1466 16.0758 12.9305 15.6301 12.8427L16.4728 12L11.9993 7.52644L11.1566 8.36913C11.0688 7.92346 10.8527 7.49828 10.5081 7.15366L9.57614 6.22166L8.27136 7.52644L7.52578 6.78085L6.78019 7.52644L7.52578 8.27202L6.221 9.5768L7.153 10.5088C7.49762 10.8534 7.9228 11.0694 8.36847 11.1573L7.52578 12L11.9993 16.4735Z"
                                fill="#1A1C19"
                              />
                              <path
                                d="M5.25975 14.264L6.77866 12.7451L8.64236 14.6087L7.12345 16.1277L5.25975 14.264Z"
                                fill="#1A1C19"
                              />
                              <path
                                d="M5.60405 19.1377L7.12296 17.6188L8.98665 19.4825L7.46774 21.0014L5.60405 19.1377Z"
                                fill="#1A1C19"
                              />
                              <path
                                d="M15.0083 4.51732L16.5272 2.99841L18.3909 4.86211L16.872 6.38102L15.0083 4.51732Z"
                                fill="#1A1C19"
                              />
                              <path
                                d="M2.995 16.5282L4.51391 15.0092L6.3776 16.8729L4.85869 18.3918L2.995 16.5282Z"
                                fill="#1A1C19"
                              />
                              <path
                                d="M15.3528 9.39119L16.8717 7.87228L18.7354 9.73597L17.2165 11.2549L15.3528 9.39119Z"
                                fill="#1A1C19"
                              />
                              <path
                                d="M17.6174 7.12699L19.1363 5.60807L21 7.47177L19.4811 8.99069L17.6174 7.12699Z"
                                fill="#1A1C19"
                              />
                            </g>
                          </g>
                        </svg>
                      </div>
                    </Tab> */}
                  </TabList>

                  <TabPanel></TabPanel>
                  <TabPanel></TabPanel>
                </Tabs>
              </div>
              <div className="map-layers">
                <div
                  className={`map-layer layer-tci ${
                    activeClass === "layer-tci" ? "active" : ""
                  }`}
                  onClick={() => this.handleLayerClick("layer-tci")}
                >
                  <img src={icon_image} alt="" width={40} />
                  <span>Image</span>
                </div>
                <div
                  className={`map-layer layer-landcover ${
                    activeClass === "layer-landcover" ? "active" : ""
                  }`}
                  onClick={() => this.handleLayerClick("layer-landcover")}
                >
                  <img src={icon_image} alt="" width={40} />
                  <span>Land cover</span>
                </div>
              </div>
            </>
          ) : null}
          <div
            id="map"
            style={{
              height: "400px",
              width: "100%",
              position: "relative",
              background: "#f9f9f9",
            }}
          ></div>
        </div>
        <Translation>
          {(t, { i18n }) => (
            <div>
              {this.state.layer_type === "Land cover" ? (
                <div className="col-sm-12">
                  <div className="tooltip-landcover">
                    <h3>{t("Landcover")}</h3>
                    {/* <img
                      src={icon_info}
                      data-tip
                      data-for="tooltip"
                      alt="tooltip"
                      width={"18px"}
                      height={"18px"}
                    /> */}
                  </div>
                  <div>
                    <div className="bar">
                      <div
                        className="tree"
                        style={{
                          width:
                            this.state.droneSummary?.landCover[3].area_perc *
                              100 +
                            "%",
                        }}
                      ></div>
                      <div
                        className="bareland"
                        style={{
                          width:
                            this.state.droneSummary?.landCover[0].area_perc *
                              100 +
                            "%",
                        }}
                      ></div>
                      <div
                        className="grass"
                        style={{
                          width:
                            this.state.droneSummary?.landCover[1].area_perc *
                              100 +
                            "%",
                        }}
                      ></div>
                      <div
                        className="water"
                        style={{
                          width:
                            this.state.droneSummary?.landCover[2].area_perc *
                              100 +
                            "%",
                        }}
                      ></div>
                    </div>
                    <div>
                      <div className="summary-landcover tree">
                        <div className="label-title">
                          <div className="bullet tree" />
                          <span>{t("Tree")}</span>
                        </div>
                        <div className="value tree">
                          {SeparatorNumber(
                            this.state.lang,
                            this.state.droneSummary?.landCover[3].area_perc *
                              100,
                            2
                          )}
                          %
                        </div>
                      </div>
                      <div className="summary-landcover bareland">
                        <div className="label-title">
                          <div className="bullet bareland" />
                          <span>{t("Bareland")}</span>
                        </div>
                        <div className="value bareland">
                          {SeparatorNumber(
                            this.state.lang,
                            this.state.droneSummary?.landCover[0].area_perc *
                              100,
                            2
                          )}
                          %
                        </div>
                      </div>
                      <div className="summary-landcover grass">
                        <div className="label-title">
                          <div className="bullet grass" />
                          <span>{t("Grass")}</span>
                        </div>
                        <div className="value grass">
                          {SeparatorNumber(
                            this.state.lang,
                            this.state.droneSummary?.landCover[1].area_perc *
                              100,
                            2
                          )}
                          %
                        </div>
                      </div>
                      <div className="summary-landcover water">
                        <div className="label-title">
                          <div className="bullet water" />
                          <span>Water</span>
                        </div>
                        <div className="value water">
                          {SeparatorNumber(
                            this.state.lang,
                            this.state.droneSummary?.landCover[2].area_perc *
                              100,
                            2
                          )}
                          %
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          )}
        </Translation>
      </React.Fragment>
    );
  }
}

export default ProgramArea;
